<template>
  <div class="demo">
    <div v-if="scrollList.length > 0">
      <ul class="list"
          v-infinite-scroll="loadMore"
          infinite-scroll-disabled="loading"
          infinite-scroll-distance="150">
        <li v-for="(item,i) in scrollList" @click="skip(item)">
          <div class="left">
            <img :src="item.poster">
            <p v-if="item.status == '直播中'"><img src="./../../../static/img/livving.png" style="height: 15px" alt=""></p>
            <p v-if="item.status == '直播'"><img src="./../../../static/img/living.png" style="height: 15px" alt=""></p>
            <p v-if="item.status == '即将开始'"><img src="./../../../static/img/nostart.png" style="height: 15px" alt=""></p>
            <p v-if="item.subjectType == 'live'"><img src="./../../../static/img/living.png" style="height: 15px" alt=""></p>
            <p v-if="item.status == '已结束'"><img src="./../../../static/img/livend.png" style="height: 15px" alt=""></p>
            <p v-if="item.status == '结束'"><img src="./../../../static/img/livend.png" style="height: 15px" alt=""></p>
            <p v-if="item.status == '视频回放'"><img src="./../../../static/img/replay.png" style="height: 15px;" alt=""></p>
            <p v-if="item.status == '回放'"><img src="./../../../static/img/replay.png" style="height: 15px" alt=""></p>
            <div v-if="play" class="Play"><img src="./../../../static/img/watch.png" alt=""></div>
          </div>
          <div class="right">
            <h3 class="title != null">{{item.title}}</h3>
            <p class="name" v-if="item.account_type == 1"><span></span>主办方：{{item.sp_name}}</p>
            <p class="name" v-if="item.guest_name != null && item.account_type == 2"><span></span>大　咖：{{item.guest_name}} &nbsp; {{ item.guest_position}}</p>
            <p class="organizer" v-if="item.subtitle != null">{{ item.subtitle }}</p>
            <p class="organizer" v-if="item.organizer != null"> <span v-show="showOrg">主办方：</span>{{ item.organizer }}</p>
            <p class="livetime" v-if="item.liveTime != null && item.pptNum == null && item.price == null">
              {{item.liveTime }}</p>
            <p class="livetime" v-if="item.liveTime != null && item.pptNum == null && item.price != null && item.price==0 && item.type!='normal'">时　间：{{
              item.liveTime }}</p>
            <p class="liveTime" v-if="item.pptNum != null && item.liveTime != null">时　间：{{ item.liveTime }}<span><img src="./../../assets/img/ppt_ico.png" style="height: 14px" /> {{ item.pptNum }}个</span></p>
            <p class="hitNum" v-if="item.price != null && item.organizerInfo == null">{{ item.hitNum }}人已观看<span
              v-if="item.price != 0 && item.price != null">￥{{ item.price }}元</span></p>
            <p class="hitNum" v-if="item.usedCount != null">{{ item.usedCount}}</p>
            <p class="pptNum" v-if="item.pptNum">{{item.pptNum}}</p>
          </div>
        </li>


      </ul>
    </div>
    <p v-if="scrollList.length == 0 && nodata" class="noData">暂无数据</p>
  </div>
</template>

<script>
  export default {
    name: 'scroll-bar',
    data() {
      return {
        dataType: '', // 这里需要把视频列表区分开 dataType video 为视频列表数据
        scrollList: [],
        currentPage: 1,
        toggle: true,
        nomore: false,
        imgurl: '',
        nodata: false,
        showOrg: true // 显示'主办方'三个字
      }
    },
    props: ["url", "tech", "play", "axiosUrl", "uType"],
    created() {
      this.initData()
    },
    computed: {
      getCommunity() {
        return this.$store.state.community;
      }
    },
    methods: {
      // 初始化
      initData () {
        window.localStorage.removeItem('url')
        let that = this;
        that.scrollList = []
        that.dataType = ''
        this.$axios
          .get(that.url + "page=" + that.currentPage)
          .then(res => {
            if (res.data.data.zslive != null) {
              that.appendData(res)
            } else {
              this.nodata = true
            }
            that.currentPage++;
          })
          .catch(err => {
            console.log(err);
          })
        window.localStorage.setItem('url', this.url)
      },
      loadMore: function () {
        if (this.nomore) {
          return;
        }
        if (this.tech) {
          return;
        }
        if (!this.toggle) {
          return;
        }
        if (this.currentPage == 1) {
          return;
        }
        this.toggle = false;
        let that = this;
        that.loading = true;
        setTimeout(() => {
          this.$axios.get(that.url + "page=" + that.currentPage).then(res => {
            that.toggle = true;
            that.appendData(res)
            that.currentPage++;
            that.loading = false;
          })
        }, 100)
      },
      skip (item) {
        // window.location.href = 'http://www.itdks.com/MobileMyInfo/detail?id=' + item.id
        window.location.href = 'https://www.itdks.com/Home/mobile/detail?id=' + item.id +'&type=bjy'
      },
      appendData(res) {
        if (res.data.code.code == 0) {
          this.scrollList = [...this.scrollList, ...res.data.data.zslive]
          if (this.scrollList.length == 0) {
            this.nodata = true
          }
        }
      }
    },
    watch: {
      url: function () {
        this.nodata = false;
        this.dataType = ''
        this.scrollList = []
        this.nomore = false
        this.currentPage = 1
        let that = this;
        this.$axios.get(that.url + "page=" + that.currentPage).then(res => {
          that.appendData(res)
          that.currentPage++
        });
      }
    }
  };
</script>

<style lang="less" scoped>
  * {
    margin: 0;
    padding: 0;
    outline: none;
  }
  h3{
    margin-top: -8px;
  }
  .demo {
    margin-bottom: 92px;
  }

  .demo .list li {
    /* width: 750px; */
    height: 219px;
    padding: 25px 28px;
    box-sizing: border-box;
    border-bottom: 1px solid #dedede; /*no*/
    list-style: none;
    .left {
      width: 270px;
      height: 169px;
      line-height: 169px;
      margin-right: 10px;
      float: left;
      border-radius: 10px;
      overflow: hidden;
      position: relative;
      display: flex;
      > img {
        width: 270px;
        height: 169px;
      }
      .Play {
        position: absolute;
        width: 50px;
        height: 50px;
        right: 5px;
        bottom: 55px;
        z-index: 10;
        img {
          width: 50px;
          height: 50px;
        }
      }
      p {
        position: absolute;
        line-height: 30px;
        left: -10px;
        color: #fff;
        top: -2px;
        font-size: 18px; /*px*/
        padding: 2px 10px;
      }
      .living {
      }
      .begin {

      }
      .agin {
      }
      .end {
      }
    }
    .right {
      width: 390px;
      margin-left: 20px;
      float: right;
      font-size: 24px; /*px*/
      .title {
        font-size: 28px; /*px*/
        // line-height: 56px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .name {
        color: #f2845a;
        margin-top: 30px;
        margin-bottom: 6px;
        height: 32px;
        overflow: hidden;
        background: url(../../assets/img/title_ico.png) no-repeat left center;
        padding-left: 28px;
        background-size: 26px 26px;
      }
      .organizer {
        color: #f3855d;
        height: 36px;
        margin-top: 12px;
        overflow: hidden;
        background: url(../../assets/img/title_ico.png) no-repeat left center;
        padding-left: 28px;
        background-size: 26px 26px;
      }
      .liveTime,
      .hitNum {
        font-size: 24px !important;
        color: #8c8c8c;
        span {
          float: right;
        }
      }
      .liveTime,.livetime{
        background: url(./../../assets/img/time_ico.png) no-repeat left center;
        padding-left: 28px;
        background-size: 26px 26px;
      }
      .hitNum {
        margin-top: 14px;
        span {
          color: #fe0200;
          font-weight: 700;
        }
      }
      .livetime {
        color: #8c8c8c;
        span {
          float: right;
        }
      }
      .pptNum{
        position: absolute;
        width: 30px;
        height: 30px;
        right: 20px;
        background: url(./../../assets/img/ppt_ico.png) no-repeat left top;
        padding-left: 30px;
        background-size: 26px 26px;
        margin-top: 10px;
      }
    }
  }
  .noData{
    width: 60vw;
    height: 70vw;
    background: url("../../assets/img/nodata.png") no-repeat;
    background-size: 60vw 58vw;
    margin: 25vw auto 0;
    text-align: center;
    color: #ccc;
    line-height: 130vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/Commons/SubScrollBars.vue